import type { ExtensionConfig, StorageProviderKind } from "@/types";

const env = import.meta.env;

export const DEFAULT_CONFIG: ExtensionConfig = {
  exposedParameterIds: [],
  requiredParameterIds: [],
  configLocked: false,
  trackingEnabled: env.VITE_ENABLE_ANALYTICS !== "false",
  saveUserName: true,
  storageProvider: (env.VITE_DEFAULT_STORAGE_PROVIDER as StorageProviderKind) ?? "csv",
  restApiBaseUrl: env.VITE_REST_API_BASE_URL || undefined,
  restApiKey: undefined,
  dbTable: "smart_rewrite_history",
  dbTableMode: "create",
  topN: 10,
  defaultTrendingWindow: "7d",
  enableAiRecommendations: env.VITE_ENABLE_AI_RECOMMENDATIONS !== "false",
  permission: "admin",
  validationRules: [],
  theme: "system",
};

export const TOP_N_OPTIONS = [3, 5, 10, 15, 20, 25, 50] as const;
